import {gql, useLazyQuery} from "@apollo/client";
import {useLogger} from "./useLogger";

const QUERY_FILTER = gql`
query getAllTags($locale: String!,$skip: Int!, $limit: Int!, $tags: [String]!) {
	pageBlogPostCollection(
		locale: $locale
        skip: $skip
        limit: $limit,
		order: publishDate_DESC,
		where: {
			contentfulMetadata: {
				tags_exists: true
				tags: { id_contains_some: $tags }
			}
		}
	) {
		total
		items{
			headerPicture{
				title
				url
			}
            contentfulMetadata{
				tags{
					id
					name
				}
			}
			titleOfTheArticle
			teaserOfTheArticle
			bloggerProfile{
				names
				picture{
					url
                    title
				}
			}
			publishDate
			category
			linkedFrom(allowedLocales: ["en-GB", "de-DE","fr-FR","it-IT","nl-NL","de-CH","de-AT"]){
				pageCollection{
					items{
						slug
					}
				}
			}
		}
	}
}

`;

export const useFilterArticles = () => {
    const {logger} = useLogger();
    const [getFilterData, {data, loading, error}] = useLazyQuery(QUERY_FILTER, {errorPolicy: "all", fetchPolicy: "no-cache"});

    if (error?.message) {
        logger(error?.message, "error", "useArticles - filter query", error?.stack);
    }

    return {
        getFilterData,
        filterArticles: data,
        loadingFilter: loading,
        errorFilter: error
    };
};
